class SimpleAccordion extends HTMLElement {
  constructor() {
    super();

    this.opener = this.querySelector('.simple-accordion--opener');
    this.content = this.querySelector('.simple-accordion--content');

    this.parent = this.parentNode;
    if (this.hasAttribute('data-parent') && this.closest(this.getAttribute('data-parent')) !== null) {
      this.parent = this.closest(this.getAttribute('data-parent'));
    }

    this.oneOpen = false;
    if (this.hasAttribute('data-one-open')) {
      this.oneOpen = true;
    }

    this.opener.addEventListener('click', this.toggle.bind(this));
  }

  get siblings() {
    const siblings = [];
    const siblingAccordions = this.parent.querySelectorAll('simple-accordion');

    for (const accordion of siblingAccordions) {
      if (accordion !== this) {
        siblings.push(accordion);
      }
    }

    return siblings;
  }

  open() {
    this.opener.setAttribute('aria-expanded', 'true');
    this.opener.classList.remove('inv');
    this.content.setAttribute('aria-hidden', 'false');

    if (this.oneOpen) {
      this.closeSiblings();
    }
  }

  close() {
    this.opener.setAttribute('aria-expanded', 'false');
    this.opener.classList.add('inv');
    this.content.setAttribute('aria-hidden', 'true');
  }

  closeSiblings() {
    for (const sibling of this.siblings) {
      sibling.close();
    }
  }

  toggle() {
    if (this.opener.getAttribute('aria-expanded') === 'true') {
      this.close();
    } else {
      this.open();
    }
  }
}

customElements.define('simple-accordion', SimpleAccordion);